<div class="h-100 nav d-flex flex-column">
  <div class="logo w-100 text-center">
    <img alt="visiotalent" src="assets/images/logo-vt-by-cc-white.svg" />
  </div>
  <div class="w-100 wrapper">
    <div class="scrollbar h-100">
      <ng-container *ngIf="mode === 'main'">
        <ng-container *ngFor="let menu of menus">
          <nav class="submenu home" *ngIf="menu.url">
            <div class="title">
              <a (click)="openQuitModal(menu)">
                <i *ngIf="menu.classIcon" class="{{ menu.classIcon }}"></i>
                <span>{{ menu.title | translate }}</span>
              </a>
            </div>
          </nav>

          <nav class="submenu main" *ngIf="!menu.url && menu.id !== 'ADMIN'">
            <div class="title">
              <i *ngIf="menu.classIcon" class="{{ menu.classIcon }}"></i>
              <span>{{ menu.title | translate }}</span>
            </div>
            <ul>
              <li *ngFor="let item of menu.children">
                <a [class.active]="isActive(item)" (click)="openQuitModal(item)">{{ item.title | translate }}</a>
              </li>
            </ul>
          </nav>
        </ng-container>

        <nav class="submenu external" *ngIf="adminLink">
          <div class="title">
            <a class="admin" (click)="openQuitModal(adminLink)">{{ 'NAVIGATION.ADMIN' | translate }}</a>
          </div>
        </nav>
      </ng-container>

      <ng-container *ngIf="mode !== 'main'">
        <div class="previous">
          <a (click)="back()">
            <i class="visiotalent-icon visiotalent-icon-chevron-big-left"></i>
            <span>{{ 'NAVIGATION.BACK' | translate }}</span>
          </a>
        </div>
        <nav class="submenu" [class.untitled]="!section.title" *ngFor="let section of sections">
          <div class="title" *ngIf="section.title">{{ section.translate ? (section.title | translate) : section.title }}</div>
          <ul>
            <li *ngFor="let item of section.items">
              <a [class.active]="isActive(item)" (click)="openQuitModal(item)">{{
                item.translate ? (item.title | translate) : item.title
              }}</a>
            </li>
          </ul>
        </nav>
      </ng-container>
    </div>
  </div>
</div>
